(function () {
  'use strict';
  if (window.__rsSmartUpsellInstalled) return;
  window.__rsSmartUpsellInstalled = true;

  var families = ['galatasaray','fenerbahce','besiktas','trabzonspor','gokturk','palestine','ottoman','turkiye','turk'];
  var extras = {mug:195,beanie:185,cap:180,baby:175,bucket:170};
  var pairings = {
    hoodie:{mug:195,beanie:185,cap:180,baby:175,bucket:170,jogger:45,shirt:35},
    zipper:{mug:195,beanie:185,cap:180,baby:175,bucket:170,jogger:45,shirt:35},
    shirt:{mug:195,beanie:185,cap:180,baby:175,bucket:170,hoodie:40,zipper:35},
    jogger:{mug:195,beanie:185,cap:180,baby:175,bucket:170,hoodie:40,zipper:35},
    windbreaker:{mug:195,beanie:185,cap:180,baby:175,bucket:170,hoodie:40,jogger:30},
    steppjacke:{mug:195,beanie:185,cap:180,baby:175,bucket:170,hoodie:40,shirt:30},
    longsleeve:{mug:195,beanie:185,cap:180,baby:175,bucket:170,jogger:40},
    kids:{baby:210,beanie:190,cap:185,mug:180,bucket:175},
    baby:{baby:215,beanie:190,cap:185,mug:180,bucket:175},
    mug:{baby:205,beanie:195,cap:190,bucket:185},
    cap:{baby:205,mug:195,beanie:190,bucket:185},
    beanie:{baby:205,mug:195,cap:190,bucket:185},
    bucket:{baby:205,mug:195,beanie:190,cap:185}
  };
  function norm(value) {
    return String(value == null ? '' : value).toLowerCase()
      .replace(/\u0131/g, 'i').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function family(text) {
    var s = ' ' + norm(text) + ' ';
    for (var i = 0; i < families.length; i++) {
      if (s.indexOf(' ' + families[i] + ' ') !== -1) return families[i];
    }
    return '';
  }
  function category(title, hint) {
    var s = norm(title);
    var t = norm(hint);
    if (/tasse|tassen|mug|becher|kupa/.test(s + ' ' + t)) return 'mug';
    if (/bucket hat|buckethat|bucket-hat|fischerhut/.test(s + ' ' + t)) return 'bucket';
    if (/beanie|mutze|mütze|strickmutze/.test(s + ' ' + t)) return 'beanie';
    if (/(^| )cap( |$)|kappe|baseball cap/.test(s + ' ' + t)) return 'cap';
    if (/baby|bebek|bodysuit|babybody|strampler|romper/.test(s + ' ' + t)) return 'baby';
    if (/kids|kinder|child|cocuk/.test(s + ' ' + t)) return 'kids';
    if (/windbreaker|windjack|coupe vent|ruzgar/.test(s + ' ' + t)) return 'windbreaker';
    if (/steppjacke|quilted|puffer|kapitone/.test(s + ' ' + t)) return 'steppjacke';
    if (/jogger|sweatpants|trainingshose/.test(s + ' ' + t)) return 'jogger';
    if (/longsleeve|long sleeve/.test(s + ' ' + t)) return 'longsleeve';
    if (/zipper|zip hoodie|zip up hoodie|hoodie zipper/.test(s + ' ' + t)) return 'zipper';
    if (/hoodie|kapuzenpullover/.test(s + ' ' + t)) return 'hoodie';
    if (/t shirt|tshirt|shirt|tee/.test(s + ' ' + t)) return 'shirt';
    return '';
  }
  function availableVariants(product) {
    if (!product || !Array.isArray(product.variants)) return [];
    return product.variants.filter(function (variant) {
      return variant && /^\d+$/.test(String(variant.id)) &&
        (variant.available === true || variant.available_for_sale === true) &&
        Number(variant.price) > 0;
    });
  }
  function relevance(main, candidate) {
    if (!candidate || String(candidate.id) === String(main.id)) return -1;
    if (candidate.available === false || candidate.gift_card === true) return -1;
    var tags = Array.isArray(candidate.tags) ? candidate.tags : String(candidate.tags || '').split(',');
    if (tags.some(function (tag) {return norm(tag) === 'sale';})) return -1;
    var mainTitle = norm(main.title), secondTitle = norm(candidate.title);
    if (!secondTitle || mainTitle === secondTitle) return -1;
    var mainGroup = category(main.title, main.template);
    var secondGroup = category(candidate.title, candidate.product_type || candidate.type);
    if (!mainGroup || !secondGroup) return -1;
    if (mainGroup !== 'baby' && mainGroup !== 'kids' && (secondGroup === 'baby' || secondGroup === 'kids')) return -1;
    var base = pairings[mainGroup] && pairings[mainGroup][secondGroup];
    if(!base){
      var firstFamily=family(main.title),nextFamily=family(candidate.title);
      var clothing={hoodie:true,zipper:true,shirt:true,jogger:true,windbreaker:true,steppjacke:true,longsleeve:true};
      if(firstFamily&&firstFamily===nextFamily&&clothing[mainGroup]&&clothing[secondGroup]&&mainGroup!==secondGroup)base=30;
    }
    if (!base) return -1;
    var primaryFamily = family(main.title), candidateFamily = family(candidate.title);
    var neutralAccessory = !candidateFamily && (secondGroup === 'cap' || secondGroup === 'beanie' || secondGroup === 'bucket');
    var turkishHeritage = ['gokturk','ottoman','turkiye','turk'];
    var relatedHeritage = turkishHeritage.indexOf(primaryFamily) >= 0 && turkishHeritage.indexOf(candidateFamily) >= 0;
    if (primaryFamily && candidateFamily !== primaryFamily && !relatedHeritage && !neutralAccessory) return -1;
    if (!primaryFamily && candidateFamily) return -1;
    if (!availableVariants(candidate).length) return -1;
    if (Number(candidate.price) <= 0) return -1;
    return base + (primaryFamily && candidateFamily === primaryFamily ? 85 : relatedHeritage ? 38 : neutralAccessory ? 2 : 0);
  }

  function pick(main,candidates,count){
    var seen=Object.create(null),seenTitle=Object.create(null),scored=[];
    (Array.isArray(candidates)?candidates:[]).forEach(function(p){
      var rank=relevance(main,p),id=String(p&&p.id),title=norm(p&&p.title);
      if(rank<0||seen[id]||seenTitle[title])return;
      seen[id]=true;seenTitle[title]=true;
      scored.push({item:p,rank:rank,kind:category(p.title,p.product_type||p.type),random:Math.random()});
    });
    scored.sort(function(a,b){return b.rank-a.rank||a.random-b.random;});
    var buckets=Object.create(null),order=[];
    scored.forEach(function(v){
      if(!buckets[v.kind]){buckets[v.kind]=[];order.push(v.kind);}
      buckets[v.kind].push(v.item);
    });
    var output=[];
    while(output.length<count){
      var something=false;
      order.forEach(function(kind){
        if(output.length<count&&buckets[kind]&&buckets[kind].length){
          output.push(buckets[kind].shift());something=true;
        }
      });
      if(!something)break;
    }
    if(output.length>2){
      var start=Math.floor(Math.random()*Math.min(4,output.length));
      if(start)output=output.slice(start).concat(output.slice(0,start));
    }
    return output;
  }
  function cents(value) {
    var n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return null;
    if (typeof value === 'string' && /^\d+\.\d{1,2}$/.test(value)) return Math.round(n * 100);
    return Math.round(n);
  }
  function money(amount, lang, currency) {
    return new Intl.NumberFormat(lang || 'de', {style:'currency', currency:currency || 'EUR'}).format(amount / 100);
  }
  function sourceImage(product) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    if (image && typeof image === 'object') image = image.src || image.url || '';
    if (typeof image !== 'string' || !image) return '';
    try {
      var url = new URL(image, window.location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      if (/cdn.shopify.com$/.test(url.hostname) || url.pathname.indexOf('/cdn/shop/') !== -1) {
        url.searchParams.set('width','800');
        url.searchParams.set('height','1200');
        url.searchParams.set('crop','center');
      }
      return url.href;
    } catch (error) {
      return '';
    }
  }

  var DETAIL_CACHE=Object.create(null);
  function variantOptions(variant) {
    if(Array.isArray(variant.options))return variant.options.map(function(x){return String(x||'');});
    return [variant.option1,variant.option2,variant.option3]
      .filter(function(x){return x!==null&&x!==undefined&&x!=='';}).map(String);
  }
  function variantImage(product,variant){
    if(!variant)return '';
    var image=variant.featured_image||variant.image||variant.featured_media;
    var url=image?sourceImage({featured_image:image}):'';
    if(url)return url;
    var photos=Array.isArray(product.images)?product.images:[];
    var associated=photos.find(function(p){
      return p&&typeof p==='object'&&Array.isArray(p.variant_ids)&&
        p.variant_ids.some(function(x){return String(x)===String(variant.id);});
    });
    return associated?sourceImage({featured_image:associated}):'';
  }
  function fullProduct(root,product) {
    var handle=String(product.handle||'');
    if(!/^[a-z0-9][a-z0-9-]*$/i.test(handle))return Promise.resolve(null);
    if(DETAIL_CACHE[handle])return DETAIL_CACHE[handle];
    var base=new URL((root.dataset.storeRoot||'/').replace(/\/?$/,'/'),window.location.origin);
    var url=new URL('products/'+handle+'.js',base);
    DETAIL_CACHE[handle]=fetch(url.toString(),{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(res){if(!res.ok)throw new Error('Product detail unavailable');return res.json();})
      .catch(function(){return null;});
    return DETAIL_CACHE[handle];
  }
  function node(tag,cls,content){
    var el=document.createElement(tag);
    if(cls)el.className=cls;
    if(content!=null)el.textContent=content;
    return el;
  }
  function showError(root, text) {
    var error = root.querySelector('[data-rs-upsell-error]');
    if (!error) return;
    error.textContent = text || '';
    error.hidden = !text;
  }
  function getPrimary(root) {
    var section = root.closest('.shopify-section') || document;
    var selector = 'form.js-product-form[data-product-id="' + root.dataset.productId + '"]';
    var form = section.querySelector(selector) || document.querySelector(selector);
    if (!form) return null;
    var idInput = form.querySelector('input[name="id"]');
    var addButton = form.querySelector('button[name="add"]');
    if (!idInput || !/^\d+$/.test(String(idInput.value || '')) || (addButton && addButton.disabled)) return null;
    var quantityField = form.querySelector('input[name="quantity"]');
    var quantity = quantityField ? Number(quantityField.value) : 1;
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) return null;
    return {id:Number(idInput.value), quantity:quantity};
  }
  async function addTogether(root, item, selected, button) {
    if (button.disabled) return;
    showError(root, '');
    var primary = getPrimary(root);
    if (!primary) {
      showError(root, root.dataset.sizeError);
      return;
    }
    var variant = availableVariants(item).find(function (v) { return String(v.id) === String(selected.value); });
    if (!variant || String(variant.id) === String(primary.id)) {
      showError(root, root.dataset.variantError);
      return;
    }
    button.disabled = true;
    var original = button.textContent;
    button.textContent = root.dataset.loading;
    try {
      var response = await fetch(root.dataset.cartAdd, {
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[
          {id:primary.id,quantity:primary.quantity,properties:{
            _rs_bundle_version:'1',_rs_bundle_role:'main',_rs_bundle_pair:String(primary.id)+'-'+String(variant.id)
          }},
          {id:Number(variant.id),quantity:1,properties:{
            _rs_bundle_version:'1',_rs_bundle_role:'addon',_rs_bundle_pair:String(primary.id)+'-'+String(variant.id),
            _rs_bundle_main_variant:String(primary.id)
          }}
        ]})
      });
      if (!response.ok) throw new Error('Cart API ' + response.status);
      window.location.assign(root.dataset.cartUrl);
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      showError(root, root.dataset.networkError);
    }
  }

  function renderCard(root,product,index){
    var variants=availableVariants(product);
    if(!variants.length)return null;
    var selected=variants[0],imageToken=0;
    var card=node('article','rs-smart-upsell__card');
    card.setAttribute('role','listitem');
    var link=(root.dataset.storeRoot||'/').replace(/\/?$/,'/')+'products/'+encodeURIComponent(String(product.handle||''));
    var photoLink=node('a','rs-smart-upsell__media');
    photoLink.href=link;
    photoLink.setAttribute('aria-label',String(product.title||''));
    var image=node('img','rs-smart-upsell__image');
    image.alt=String(product.title||'');
    image.src=variantImage(product,selected)||sourceImage(product);
    image.loading='lazy';image.decoding='async';
    image.width=300;image.height=450;
    if(!image.src)photoLink.classList.add('rs-smart-upsell__media--empty');
    photoLink.appendChild(image);
    card.appendChild(photoLink);

    var body=node('div','rs-smart-upsell__body');
    var title=node('a','rs-smart-upsell__product',product.title);
    title.href=link;body.appendChild(title);
    var price=node('div','rs-smart-upsell__price');
    price.setAttribute('aria-live','polite');
    body.appendChild(price);

    var moreThanOne=variants.length>1;
    var action=node('button','rs-smart-upsell__action',moreThanOne?(root.dataset.rsSelect||root.dataset.button):root.dataset.button);
    action.type='button';
    body.appendChild(action);
    card.appendChild(body);

    var options=variants.map(variantOptions),axisCount=options[0].length;
    var separable=axisCount>0&&axisCount<=3&&options.every(function(o){
      return o.length===axisCount&&o.every(Boolean);
    });
    var selects=[],fallback=null,colorAxis=0;
    var panel=node('div','rs-smart-upsell__config');
    panel.hidden=true;
    var panelId='rs-upsell-choose-'+String(root.dataset.productId||'p')+'-'+index;
    panel.id=panelId;
    action.setAttribute('aria-expanded','false');
    if(moreThanOne)action.setAttribute('aria-controls',panelId);

    if(moreThanOne){
      var panelHead=node('div','rs-smart-upsell__config-head');
      panelHead.appendChild(node('span','rs-smart-upsell__config-title',root.dataset.rsSelect||root.dataset.variant||'Variante'));
      var close=node('button','rs-smart-upsell__config-close','×');
      close.type='button';
      close.setAttribute('aria-label',root.dataset.rsClose||'Schließen');
      panelHead.appendChild(close);
      panel.appendChild(panelHead);
      var row=node('div','rs-smart-upsell__variant-row');
      if(Array.isArray(product.options)){
        var pos=product.options.findIndex(function(o){
          var n=String(typeof o==='string'?o:o&&o.name||'');
          return /farbe|color|colour|couleur|kleur|renk/i.test(n);
        });
        if(pos>=0)colorAxis=pos;
      }
      if(separable){
        var labels=Array.isArray(product.options)?product.options.map(function(o){
          return String(typeof o==='string'?o:o&&o.name||'');
        }):[];
        for(var i=0;i<axisCount;i++){
          var distinct=[];
          options.forEach(function(values){if(distinct.indexOf(values[i])<0)distinct.push(values[i]);});
          if(distinct.length<2)continue;
          var label=labels[i]||'';
          if(/farbe|color|colour|couleur|kleur|renk/i.test(label))label=root.dataset.rsColor||label;
          else if(/größe|groesse|size|taille|maat|beden/i.test(label))label=root.dataset.rsSize||label;
          else if(!label)label=(i===0?root.dataset.rsColor:root.dataset.rsSize)||root.dataset.variant||'Variante';
          var wrap=node('label','rs-smart-upsell__option');
          wrap.appendChild(node('span','rs-smart-upsell__label',label));
          var select=node('select','rs-smart-upsell__variant');
          select.setAttribute('aria-label',label);
          distinct.forEach(function(value){
            var option=node('option','',value);
            option.value=value;
            select.appendChild(option);
          });
          select.value=variantOptions(selected)[i];
          selects.push({index:i,el:select});
          wrap.appendChild(select);
          row.appendChild(wrap);
        }
      }
      if(!selects.length){
        var selectWrap=node('label','rs-smart-upsell__option');
        selectWrap.appendChild(node('span','rs-smart-upsell__label',root.dataset.variant||'Variante'));
        fallback=node('select','rs-smart-upsell__variant');
        fallback.setAttribute('aria-label',root.dataset.variant||'Variante');
        variants.forEach(function(v){
          var option=node('option','',v.public_title||v.title||String(v.id));
          option.value=String(v.id);
          fallback.appendChild(option);
        });
        fallback.value=String(selected.id);
        selectWrap.appendChild(fallback);
        row.appendChild(selectWrap);
      }
      panel.appendChild(row);
      var confirm=node('button','rs-smart-upsell__confirm',root.dataset.button||'Zusammen kaufen');
      confirm.type='button';
      confirm.addEventListener('click',function(){addTogether(root,product,{value:String(selected.id)},confirm);});
      panel.appendChild(confirm);
      card.appendChild(panel);
      function setPanel(isOpen){
        if(isOpen&&root.querySelectorAll){
          root.querySelectorAll('.rs-smart-upsell__config').forEach(function(other){
            if(other===panel)return;
            other.hidden=true;
            var otherCard=other.closest('.rs-smart-upsell__card');
            if(otherCard){
              otherCard.classList.remove('rs-smart-upsell__card--open');
              var otherAction=otherCard.querySelector('.rs-smart-upsell__action');
              if(otherAction)otherAction.setAttribute('aria-expanded','false');
            }
          });
        }
        panel.hidden=!isOpen;
        action.setAttribute('aria-expanded',String(isOpen));
        if(isOpen)card.classList.add('rs-smart-upsell__card--open');
        else card.classList.remove('rs-smart-upsell__card--open');
      }
      action.addEventListener('click',function(){
        setPanel(panel.hidden);
      });
      close.addEventListener('click',function(){
        setPanel(false);
        if(action.focus)action.focus({preventScroll:true});
      });
    }else{
      action.addEventListener('click',function(){
        addTogether(root,product,{value:String(selected.id)},action);
      });
    }

    function priceSync(){
      var amount=cents(selected.price);
      var compare=cents(selected.compare_at_price!=null?selected.compare_at_price:selected.compareAtPrice);
      price.textContent='';
      if(amount==null)return;
      var verified=root.dataset.promotionVerified==='true';
      var actual=verified?Math.round(amount*.9):amount;
      var previous=verified?(compare!=null&&compare>amount?compare:amount):compare;
      price.appendChild(node('span','rs-smart-upsell__now',money(actual,root.dataset.lang,root.dataset.currency)));
      if(previous!=null&&previous>actual){
        price.appendChild(node('del','rs-smart-upsell__was',money(previous,root.dataset.lang,root.dataset.currency)));
      }
    }
    function imageSync(loadMissing){
      var token=++imageToken;
      var found=variantImage(product,selected);
      if(found){
        image.src=found;
        photoLink.classList.remove('rs-smart-upsell__media--empty');
        return;
      }
      if(!loadMissing)return;
      var id=String(selected.id);
      fullProduct(root,product).then(function(detail){
        if(token!==imageToken||!detail)return;
        var exact=Array.isArray(detail.variants)?detail.variants.find(function(v){return String(v.id)===id;}):null;
        var imageURL=variantImage(detail,exact);
        if(imageURL){
          image.src=imageURL;
          image.alt=String(product.title||'')+(exact&&exact.public_title?' – '+exact.public_title:'');
          photoLink.classList.remove('rs-smart-upsell__media--empty');
        }
      });
    }
    function update(changed){
      if(fallback){
        selected=variants.find(function(v){return String(v.id)===String(fallback.value);})||selected;
      }else if(selects.length){
        var wanted=variantOptions(selected);
        selects.forEach(function(s){wanted[s.index]=s.el.value;});
        var exact=variants.find(function(v){
          return variantOptions(v).every(function(val,i){return val===wanted[i];});
        });
        if(!exact&&changed>=0){
          var changedSelect=selects.find(function(s){return s.index===changed;});
          if(changedSelect){
            exact=variants.find(function(v){return variantOptions(v)[changed]===changedSelect.el.value;});
          }
        }
        if(exact)selected=exact;
        selects.forEach(function(s){s.el.value=variantOptions(selected)[s.index];});
        selects.forEach(function(s){
          Array.from(s.el.options).forEach(function(opt){
            opt.disabled=!variants.some(function(v){
              var opts=variantOptions(v);
              return opts[s.index]===opt.value&&(
                s.index===colorAxis||selects.every(function(other){
                  return other.index===s.index||opts[other.index]===other.el.value;
                })
              );
            });
          });
        });
      }
      priceSync();
      imageSync(changed>=0);
    }
    selects.forEach(function(s){
      s.el.addEventListener('change',function(){update(s.index);});
      s.el.addEventListener('focus',function(){if(!variantImage(product,selected))fullProduct(root,product);});
    });
    if(fallback){
      fallback.addEventListener('change',function(){update(0);});
      fallback.addEventListener('focus',function(){if(!variantImage(product,selected))fullProduct(root,product);});
    }
    update(-1);
    return card;
  }
  async function fetchRecommendations(root, intent) {
    var url = new URL(root.dataset.endpoint, window.location.origin);
    url.searchParams.set('product_id',root.dataset.productId);
    url.searchParams.set('limit','10');
    url.searchParams.set('intent',intent);
    try {
      var response = await fetch(url.toString(),{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if (!response.ok) return [];
      var data = await response.json();
      return Array.isArray(data.products) ? data.products : [];
    } catch (error) {
      return [];
    }
  }
  var collectionHandles = {
    galatasaray:'galatasaray-streetwear',
    fenerbahce:'fenerbahce-streetwear',
    besiktas:'besiktas-streetwear',
    trabzonspor:'fussball',
    gokturk:'osmanli',
    ottoman:'osmanli',
    turkiye:'turkiye-streetwear',
    palestine:'palestine'
  };
  async function fetchCollection(root, handle) {
    try {
      var storeRoot = (root.dataset.storeRoot || '/').replace(/\/?$/, '/');
      var base = new URL(storeRoot,window.location.origin);
      var url = new URL('collections/' + handle + '/products.json',base);
      url.searchParams.set('limit','50');
      var response = await fetch(url.toString(),{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if (!response.ok) return [];
      var data = await response.json();
      return Array.isArray(data.products) ? data.products : [];
    } catch (error) {
      return [];
    }
  }

  function updateNav(root){
    var rail=root.querySelector('[data-rs-upsell-list]');
    var prev=root.querySelector('[data-rs-upsell-prev]');
    var next=root.querySelector('[data-rs-upsell-next]');
    var count=root.querySelector('[data-rs-upsell-count]');
    if(!rail||!prev||!next)return;
    var available=Math.max(0,rail.scrollWidth-rail.clientWidth);
    prev.disabled=available<4||rail.scrollLeft<4;
    next.disabled=available<4||rail.scrollLeft>=available-4;
    if(count){
      var total=rail.children.length;
      if(!total){count.textContent='';return;}
      var card=rail.querySelector('.rs-smart-upsell__card');
      var width=card&&card.getBoundingClientRect?card.getBoundingClientRect().width:rail.clientWidth;
      var gap=window.matchMedia&&window.matchMedia('(max-width: 749px)').matches?10:12;
      var step=Math.max(1,width+gap);
      var visible=Math.max(1,Math.min(total,Math.round((rail.clientWidth+gap)/step)));
      var first=Math.min(Math.max(0,total-visible),Math.max(0,Math.round(rail.scrollLeft/step)))+1;
      count.textContent=visible===1?first+' / '+total:first+'–'+Math.min(total,first+visible-1)+' / '+total;
    }
  }
  function render(root){
    var rail=root.querySelector('[data-rs-upsell-list]'),main=root.__rsMain;
    if(!rail||!main)return;
    var list=pick(main,root.__rsPool||[],12);
    if(list.length>1&&root.__rsFirst&&String(list[0].id)===root.__rsFirst){
      list=list.slice(1).concat(list[0]);
    }
    root.__rsFirst=list[0]&&String(list[0].id);
    rail.textContent='';
    list.forEach(function(p,i){var card=renderCard(root,p,i);if(card)rail.appendChild(card);});
    root.hidden=list.length===0;
    var refresh=root.querySelector('[data-rs-upsell-refresh]');
    if(refresh)refresh.disabled=list.length<2;
    if(typeof rail.scrollTo==='function')rail.scrollTo({left:0,behavior:'auto'});
    else rail.scrollLeft=0;
    updateNav(root);
  }
  function navigation(root){
    if(root.dataset.rsNavigationReady)return;
    root.dataset.rsNavigationReady='true';
    var rail=root.querySelector('[data-rs-upsell-list]'),
      prev=root.querySelector('[data-rs-upsell-prev]'),
      next=root.querySelector('[data-rs-upsell-next]'),
      refresh=root.querySelector('[data-rs-upsell-refresh]');
    function move(direction){
      if(!rail)return;
      var card=rail.querySelector('.rs-smart-upsell__card');
      var gap=window.matchMedia&&window.matchMedia('(max-width: 749px)').matches?10:12;
      var amount=card?card.getBoundingClientRect().width+gap:Math.max(120,rail.clientWidth*.5);
      var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(typeof rail.scrollBy==='function')rail.scrollBy({left:direction*amount,behavior:reduced?'auto':'smooth'});
      else rail.scrollLeft+=direction*amount;
      if(window.requestAnimationFrame)window.requestAnimationFrame(function(){updateNav(root);});
    }
    if(prev)prev.addEventListener('click',function(){move(-1);});
    if(next)next.addEventListener('click',function(){move(1);});
    if(refresh)refresh.addEventListener('click',function(){render(root);});
    if(rail)rail.addEventListener('scroll',function(){updateNav(root);},{passive:true});
    if(rail&&'ResizeObserver' in window){
      root.__rsResizeObserver=new ResizeObserver(function(){updateNav(root);});
      root.__rsResizeObserver.observe(rail);
    }
  }
  async function load(root){
    if(root.dataset.rsLoaded)return;
    root.dataset.rsLoaded='true';
    var main={id:root.dataset.productId,title:root.dataset.productTitle,template:root.dataset.productTemplate};
    root.__rsMain=main;
    navigation(root);
    try{
      var candidates=await Promise.all([
        fetchCollection(root,'accessories'),
        fetchCollection(root,'kids'),
        fetchRecommendations(root,'complementary')
      ]);
      var pool=candidates[0].concat(candidates[1],candidates[2]);
      var adultStyle = /^(hoodie|zipper|shirt|jogger|windbreaker|steppjacke|longsleeve)$/.test(category(main.title,main.template));
      if(pick(main,pool,12).length<10 || (adultStyle && family(main.title))){
        var handle=collectionHandles[family(main.title)]||'bestseller-sortiment-v2';
        var extra=await Promise.all([fetchCollection(root,handle),fetchRecommendations(root,'related')]);
        pool=pool.concat(extra[0],extra[1]);
      }
      root.__rsPool=pool;
      render(root);
    }catch(error){root.hidden=true;}
  }
  function moveBeforePhotos(root) {
    var photos = document.querySelector('#rs-ugc-shell');
    if (!photos || !photos.parentNode) return false;
    if (root.nextElementSibling !== photos) photos.parentNode.insertBefore(root,photos);
    root.classList.add('rs-smart-upsell--before-photos');
    return true;
  }
  function init() {
    document.querySelectorAll('[data-rs-smart-upsell]').forEach(function (root) {
      if (root.dataset.rsPlacement !== 'inline') moveBeforePhotos(root);
      if (root.dataset.rsLoaded) return;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () {load(root);},{timeout:1400});
      } else {
        window.setTimeout(function () {load(root);},160);
      }
    });
  }
  if (window.Shopify && window.Shopify.designMode) {
    window.__rsSmartUpsellTest = {norm:norm,family:family,category:category,relevance:relevance,pick:pick,availableVariants:availableVariants,cents:cents,fetchCollection:fetchCollection,moveBeforePhotos:moveBeforePhotos,render:render,load:load,navigation:navigation,renderCard:renderCard,variantOptions:variantOptions,variantImage:variantImage,fullProduct:fullProduct};
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();